<!-- This is a template for the form sections. It can be reused for both workflow forms and approval forms -->
<ng-template
    #attachmentList
    let-relatedEntity="relatedEntity"
    let-approvalId="approvalId"
    let-readonly="readonly"
>
    <ng-container *ngFor="let attachment of relatedEntity.attachments">
        <ng-container
            *ngIf="
                (requiredAttachmentsPerApproval[approvalId] &&
                    requiredAttachmentsPerApproval[approvalId][
                        attachment.entity?.id
                    ]) ||
                approvalId === -1
            "
        >
            <div class="form-group input-content row">
                <label
                    class="col-xs-3 control-label"
                    [ngClass]="{ readonly: readonly }"
                    >{{ attachment.entity.name }}
                    <field-validation-indicator
                        [required]="attachment.entity.minimumInstances > 0"
                        [valid]="attachment.valid"
                        [hasValue]="attachment.hasValue"
                        noun="attachment"
                    ></field-validation-indicator>
                </label>
                <div class="col-xs-9">
                    <attachment-list
                        [attachmentsHandler]="attachmentsHandler"
                        [allowUploads]="!attachment.metMaximum"
                        [allowReuploads]="true"
                        [allowDelete]="true"
                        [allowEdit]="true"
                        [parentPromiseTracker]="workTracker"
                        [disabled]="readonly"
                        [requirementId]="attachment.entity.id"
                        permissions
                    >
                    </attachment-list>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-template>
<ng-template
    #documentList
    let-relatedEntity="relatedEntity"
    let-approvalId="approvalId"
    let-readonly="readonly"
>
    <ng-container *ngFor="let form of relatedEntity.forms; let first = first">
        <ng-container
            *ngIf="
                (requiredFormsPerApproval[approvalId] &&
                    requiredFormsPerApproval[approvalId][
                        form.entity?.formId
                    ]) ||
                approvalId === -1
            "
        >
            <div class="form-group input-content row">
                <label
                    class="col-xs-3 control-label"
                    [ngClass]="{ readonly: readonly }"
                    >{{ form.entity.formName }}
                    <field-validation-indicator
                        [required]="form.required"
                        [valid]="form.completed"
                        [hasValue]="
                            form.completed === true ||
                            form.progress.progress > 0
                        "
                        noun="document"
                    ></field-validation-indicator
                ></label>
                <div class="col-xs-9">
                    <p [ngClass]="{ readonly: readonly }">
                        {{ form.entity.description }}
                    </p>
                    <p
                        *ngIf="
                            prefillErrors != null &&
                            prefillErrors[form.entity.formId]
                        "
                        class="alert alert-warning"
                    >
                        <span class="fal fa-info-circle right-buffer"></span>
                        This documentation could not be prefilled, probably
                        because the active version is different to the prefill
                        version
                    </p>

                    <button
                        *ngIf="!readonly"
                        class="btn btn-default btn-confirm"
                        type="button"
                        (click)="showForm(relatedEntity, form)"
                    >
                        <span
                            *ngIf="
                                !form.completed && form.progress.progress === 0
                            "
                        >
                            Start
                        </span>
                        <span
                            *ngIf="
                                !form.completed && form.progress.progress > 0
                            "
                        >
                            Continue
                        </span>
                        <span *ngIf="form.completed"> Done </span>
                    </button>
                    <!-- The documentation can always be viewed, even when it can't be edited -->
                    <button
                        *ngIf="readonly"
                        class="btn btn-default btn-confirm"
                        type="button"
                        (click)="showFormResponse(relatedEntity, form)"
                    >
                        View
                    </button>
                </div>
            </div>
        </ng-container>
    </ng-container>
</ng-template>

<!-- Next we iterate through the non-approval entities, e.g. the mission workflow and each RPA, -->
<!-- and display each one in its own block, in the same style as the approval blocks -->
<div
    *ngIf="documentationResponses != null && documentationResponses.length > 0"
    class="horizontal-container wrap container-scroll"
>
    <ng-container *ngFor="let relatedEntity of documentationResponses">
        <div
            *ngIf="
                relatedEntity.forms.length > 0 ||
                relatedEntity.attachments.length > 0
            "
            class="vertical-container contents approval-data approval-documentation"
        >
            <h4 class="inline-heading">
                <!-- The mission workflow documentation has no related entity, so it is -->
                <!-- labelled with the name of the workflow the mission is using -->
                <ng-container *ngIf="relatedEntity.relatedEntityType == null">
                    Mission Workflow<ng-container
                        *ngIf="missionWorkflowName != null"
                        >: {{ missionWorkflowName }}</ng-container
                    >
                </ng-container>
                <ng-container *ngIf="relatedEntity.relatedEntityType != null">
                    {{ relatedEntity.name }}
                </ng-container>
            </h4>
            <div
                *ngIf="relatedEntity.forms.length > 0"
                class="vertical-container"
            >
                <h4 class="inline-heading">Documentation</h4>
                <ng-container
                    [ngTemplateOutlet]="documentList"
                    [ngTemplateOutletContext]="{
                        relatedEntity: relatedEntity,
                        approvalId: -1,
                        readonly: readonly
                    }"
                ></ng-container>
            </div>
            <div
                *ngIf="
                    relatedEntity.attachments.length > 0 && attachments != null
                "
                class="vertical-container"
            >
                <h4 class="inline-heading">Attachments</h4>
                <ng-container
                    [ngTemplateOutlet]="attachmentList"
                    [ngTemplateOutletContext]="{
                        relatedEntity: relatedEntity,
                        approvalId: -1,
                        readonly: readonly
                    }"
                ></ng-container>
            </div>
        </div>
    </ng-container>
</div>

<!-- Now we iterate through the mission approvals and create an element housing all -->
<!-- its forms and attachments for each approval. They are displayed horizontally -->
<div
    *ngIf="
        activeApprovals &&
        activeApprovals.length &&
        approvalDocumentationResponses != null
    "
    class="horizontal-container wrap container-scroll"
>
    <ng-container *ngFor="let approval of activeApprovals; let i = index">
        <div
            class="vertical-container contents approval-data approval-documentation"
        >
            <div class="vertical-container" style="min-height: 10rem">
                <h4 class="inline-heading">
                    Approval {{ i + 1 }}
                    <mission-approval-status
                        [status]="approval.approval.status"
                    ></mission-approval-status>
                </h4>
                <span class="top-buffer bottom-buffer"
                    ><strong>Ruleset:</strong>
                    {{
                        approval.authorityType?.ruleset?.name != null
                            ? approval.authorityType?.ruleset?.name
                            : 'None'
                    }}
                </span>
                <span
                    ><strong>Authority:</strong>
                    {{
                        (getSimplifiedAuthorityFromApproval(
                            approval,
                            organisation
                        ) | formatAuthority) || 'None'
                    }}
                </span>
            </div>
            <div class="vertical-container">
                <h4 class="inline-heading">Documentation</h4>
                <ng-container
                    [ngTemplateOutlet]="documentList"
                    [ngTemplateOutletContext]="{
                        relatedEntity: approvalDocumentationResponses,
                        approvalId: approval.approval.id,
                        readonly: readonly
                    }"
                ></ng-container>
            </div>
            <div
                *ngIf="requiredAttachmentsPerApproval[approval.approval.id]"
                class="vertical-container"
            >
                <h4 class="inline-heading">Attachments</h4>
                <ng-container
                    [ngTemplateOutlet]="attachmentList"
                    [ngTemplateOutletContext]="{
                        relatedEntity: approvalDocumentationResponses,
                        approvalId: approval.approval.id,
                        readonly: readonly
                    }"
                ></ng-container>
            </div>
        </div>
    </ng-container>
</div>
